import React from "react";

const SPADE_LOGO =
    "https://customer-assets.emergentagent.com/job_biat-casino-elite/artifacts/kp8xcuo8_fb74053f3e0745f1820417a5e7656a7b.webp";

/**
 * Spade emblem rendered from the user-provided gold spade image.
 */
export const SpadeEmblem = ({ size = 48, className = "" }) => (
    <img
        src={SPADE_LOGO}
        alt="CasinoBiat"
        width={size}
        height={size}
        className={`block object-contain ${className}`}
        style={{ width: size, height: size }}
    />
);
